import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { darkColors } from "../../../theme/colors";
import { assetImages } from "../../../constants/assets";

// Import your asset images

const WalletSelectionDialog = ({ open, onClose, onSelectWallet }) => {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const walletOptions = [
    {
      id: "metamask",
      name: "MetaMask",
      icon: assetImages.metamask,
      gradient: "linear-gradient(135deg, #8B4513 0%, #D2B48C 100%)", // Brown gradient
    },
    {
      id: "coinbase",
      name: "Coinbase",
      icon: assetImages.coinbase,
      gradient: "linear-gradient(135deg, #1652F0 0%, #6366F1 100%)", // Blue gradient
    },
    {
      id: "trustwallet",
      name: "Trust Wallet",
      icon: assetImages.trustWallet,
      gradient: "linear-gradient(135deg, #4A90E2 0%, #7BB3F0 100%)", // Light blue gradient
    },
  ];

  const visibleWallets = isMediumScreen
    ? walletOptions.slice(0, 2)
    : walletOptions;

  return (
    <Dialog
      PaperProps={{
        style: {
          background: "transparent",
          boxShadow: "none",
        },
      }}
      BackdropProps={{
        sx: {
          backdropFilter: "blur(12px)", // blur effect
          backgroundColor: "rgba(0,0,0,0.5)", // dark overlay + blur
        },
      }}
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle
        sx={{
          color: "white",
          textAlign: "center",
          fontSize: "1.5rem",
          fontWeight: 700,
          pb: 2,
        }}
      >
        Select a Wallet
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 2 }}>
        <Grid container spacing={2} justifyContent="center">
          {visibleWallets.map((wallet) => (
            <Grid item size={{ xs: 8, lg: 4 }} key={wallet.id}>
              <Card
                sx={{
                  background: wallet.gradient,
                  borderRadius: "12px",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
                  },
                }}
                onClick={() => onSelectWallet(wallet.id)}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 5,
                    width: 280,
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{
                      color: "white",
                      fontWeight: "500",
                      // fontSize: "0.95rem",
                      textAlign: "center",
                      textShadow: "0 1px 2px rgba(0, 0, 0, 0.3)",
                    }}
                  >
                    {wallet.name}
                  </Typography>
                  <Box
                    component="img"
                    src={wallet.icon}
                    alt={wallet.name}
                    sx={{
                      width: 80,
                      height: 80,
                      opacity: 0.8,
                      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2))",
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, justifyContent: "center" }}>
        <Button
          onClick={onClose}
          sx={{
            color: "rgba(255, 255, 255, 0.7)",
            "&:hover": {
              color: "white",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WalletSelectionDialog;
